import React, { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { formatDate } from "../lib/utils";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="space-y-6 max-w-3xl">
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">Bandeja</div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Notificaciones</h1>
        </div>
        <button onClick={markAll} className="inline-flex items-center gap-2 text-sm border border-slate-300 rounded-md px-3 py-2 hover:bg-slate-50" data-testid="notif-mark-all"><CheckCheck className="w-4 h-4" /> Marcar todas como leídas</button>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg divide-y divide-slate-100">
        {items.map(n => (
          <div key={n.id} className={`p-4 flex items-start gap-3 ${!n.read ? "bg-red-50/40" : ""}`}>
            <div className={`w-9 h-9 rounded-md flex items-center justify-center ${n.read ? "bg-slate-100 text-slate-500" : "bg-red-50 text-crejpp"}`}>
              <Bell className="w-4 h-4" />
            </div>
            <div className="flex-1">
              <div className="text-sm text-slate-800" dangerouslySetInnerHTML={{ __html: n.message }} />
              <div className="text-xs text-slate-500 mt-1">{formatDate(n.created_at)}</div>
              <div className="mt-1 flex gap-3 text-xs">
                {n.task_id && <Link to="/tareas" className="text-crejpp hover:underline">Ver tareas</Link>}
                {n.project_id && <Link to={`/proyectos/${n.project_id}`} className="text-crejpp hover:underline">Ver proyecto</Link>}
                {!n.read && <button onClick={() => markRead(n.id)} className="text-slate-500 hover:underline" data-testid={`notif-mark-read-${n.id}`}>Marcar como leída</button>}
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="p-12 text-center text-sm text-slate-400">Sin notificaciones.</div>}
      </div>
    </div>
  );
}
